import ParkingSpotPricePage from "./parkingSpotPrice";

export default ParkingSpotPricePage;